import { useComponent, useElement, useLocale } from "../../../hooks";
import { useAddCampaign } from "./hooks";

export const AddCampaign = () => {
  const { t } = useLocale();
  const BackIcon = useElement("BackIcon");
  const Input = useElement("Input");
  const Button = useElement("Button");
  const Box = useComponent("Box");
  const {
    mode,
    name,
    setCampaignName,
    content,
    setCampaignContent,
    addCampaign,
  } = useAddCampaign();
  return (
    <div id="content-box" className="content">
      <h1>
        <BackIcon backLink="/admin/campaign/list" />
        {mode + " Campaign"}
      </h1>
      <div className="columns">
        <div className="left">
          <Box title={t("name")} required>
            <Input
              required
              name="name"
              value={name}
              onChange={setCampaignName}
            />
          </Box>
          <Box title="Content" required>
            <textarea
              className="description"
              placeholder={t("placeholder.content")}
              required
              name="content"
              value={content}
              onChange={setCampaignContent}
            ></textarea>
          </Box>
        </div>
        <div className="right">
          <form noValidate onSubmit={addCampaign}>
            <Box title={t("meta")}>
              <Button
                className="btn btn-primary"
                type="submit"
                title="Click here to Add campaign"
              >
                {t("publish")}
              </Button>
            </Box>
          </form>
        </div>
      </div>
    </div>
  );
};
